var App = App || {};

App.Bootstrap = (function () {
    'use strict';

    // Initializes Bootstrap element arrays and activates any element referenced by the current URL hash.
    const getElements = (context) => {
        return {
            accordionElements: [...context.querySelectorAll(".accordion-button")]
                .filter(element => element.id)
                .map(element => `#${element.id}`),
            tabElements: [...context.querySelectorAll(".nav-tabs .nav-link")]
                .filter(element => element.id)
                .map(element => `#${element.id}`)
        };
    };

    // Activates a Bootstrap element based on the given hash if present in the DOM.
    const activateElement = (context, href) => {
        if (!href || href === "#") return;

        // Determine the type and get the processed candidate
        const bootstrapElements = getElements(context);
        const { type: elementType, candidate: candidate } = resolveElementType(bootstrapElements, href);
        if (!elementType) return;

        // Main logic for different Bootstrap element types
        if (elementType === "accordionElements") {

            const button = context.querySelector(`${candidate}`);
            const panel = context.querySelector(`${candidate}_Target`);
            if (!button || !panel) return;

            const collapse = bootstrap.Collapse.getOrCreateInstance(panel, { toggle: true });
            collapse.show();
            button.focus();

            App.Helpers.scrollToElement(button);
            return true;
        }

        if (elementType === "tabElements") {

            const button = context.querySelector(`${candidate}`);
            if (!button) return;

            const tab = bootstrap.Tab.getOrCreateInstance(button);
            tab.show();
            button.focus();
            App.Helpers.scrollToElement(button);
            return true;
        }
    };

    // Determines the type of Bootstrap element and returns its type and processed candidate selector.
    const resolveElementType = (bootstrapElements, candidate) => {
        // Return false if candidate is empty
        if (!candidate) return false;

        // Remove pathname prefix if present (case-insensitive)
        const pathName = window.location.pathname;
        if (candidate.toLowerCase().startsWith(pathName.toLowerCase())) {
            candidate = candidate.slice(pathName.length);
        }

        // Must start with "#"
        if (!candidate.startsWith("#")) return false;

        // Find the type in bootstrapElements
        const type = Object.keys(bootstrapElements).find(key =>
            bootstrapElements[key].includes(candidate)
        ) ?? false;

        // Return both the type and the processed candidate
        return { type, candidate };
    };

    return {
        activateElement
    };

})();